import {InteractionType} from "@azure/msal-browser";

export const authConfig = {
    auth: {
        clientId: "e2f42359-b1b3-4d7c-8e33-24f1360dc3b3",
        authority: "https://id.legeforeningen.no/legeforeningenb2c.onmicrosoft.com/b2c_1a_v1_signupsignin",
        knownAuthorities: ["id.legeforeningen.no"],
        redirectUri: "/",
        responseType: "code",
        postLogoutRedirectUri: "https://legeforeningen.no"
    }
    ,
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }, interactionType: InteractionType.Redirect,
    authRequest: {
        scopes: ['openid']
    }
}
